const TYPE = 'vehicle.locatorPaired.False';
const attrName = 'vehicle.locatorPaired';
function create() {
  return {
    type: TYPE
  };
}
export default {
  type: TYPE,
  TYPE,
  attrName,
  name: 'is false',
  create,
  isPreferred() {
    return false;
  }
};